module.exports = __webpack_public_path__ + "img/OT462.c2f5433.webp";